import Box from '@mui/material/Box'
import { cellBackground } from './cellBackground.jsx'

export function HeatmapCell({ level }) {
  return (
    <Box
      sx={{
        width: 16,
        height: 16,
        flexShrink: 0,
        borderRadius: '2px',
        bgcolor: cellBackground(level),
        boxSizing: 'border-box',
      }}
    />
  )
}
